export const TUTORIAL_LINK = 'https://help.shootsta.com/en/articles/5136191-how-to-download-and-install-shootsta-cast';

export const CAST_LITE_EXTENSION_LINK =
  'https://chromewebstore.google.com/detail/shootsta-screen-recording/fpoepdkeejnenblhfogdkcbfjjgpnlel';